import { Button } from "@/components/ui/button";
import type { LucideIcon } from "lucide-react";

interface PermissionScreenProps {
  icon: LucideIcon;
  title: string;
  bullets: readonly string[];
  onEnable: () => void;
  onSkip: () => void;
  isRequesting: boolean;
}

export function PermissionScreen({
  icon: Icon,
  title,
  bullets,
  onEnable,
  onSkip,
  isRequesting,
}: PermissionScreenProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto mb-6 h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon className="h-8 w-8 text-primary" />
        </div>

        <h1 className="text-2xl font-bold mb-6">{title}</h1>

        <ul className="text-left space-y-3 mb-8">
          {bullets.map((bullet, index) => (
            <li key={index} className="flex items-start gap-3 text-muted-foreground">
              <span className="text-primary mt-1">•</span>
              <span>{bullet}</span>
            </li>
          ))}
        </ul>

        <div className="space-y-3">
          <Button
            onClick={onEnable}
            disabled={isRequesting}
            className="w-full"
            size="lg"
          >
            {isRequesting ? "Requesting..." : "Enable"}
          </Button>
          <Button
            variant="ghost"
            onClick={onSkip}
            disabled={isRequesting}
            className="w-full"
          >
            Maybe Later
          </Button>
        </div>
      </div>
    </div>
  );
}
